// extracted by mini-css-extract-plugin
module.exports = {"contact":"Y_dZ","contact__wrapper":"Y_d0","error__select":"Y_d1","error__input":"Y_d2"};